import { CircleExclamationIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../Translations';

interface Props {
  message: TPlainTextKey;
}

function AccessRestrictionMessage({ message }: Props) {
  return (
    <div className="bg-[#FD8600] w-full p-2 flex justify-center items-center ">
      <Typography variant="bodyMedium" color="white" className="mr-2">
        <T kind={message} />
      </Typography>
      <CircleExclamationIcon size="md" color="white" />
    </div>
  );
}

export default observer(AccessRestrictionMessage);
